<template>
  <footer class="policorp-footer">
    <div class="footer-columns">
      <!-- Coluna Institucional -->
      <div class="footer-column">
        <div class="footer-title-container">
          <h2 class="footer-title">Institucional</h2>
          <div class="title-line"></div>
        </div>
        <ul class="footer-list">
           <li><a href="https://policorp.com.br/" class="footer-link">Sobre a policorp</a></li>
          <li><a href="https://policorp.com.br/policorp-linux" class="footer-link">Policorp Linux</a></li>
          <li><a href="https://policorp.com.br/produtos-e-servicos" class="footer-link">Produtos & Serviços</a></li>
          <li><a href="https://hcl.policorp.com.br/" class="footer-link">HCL</a></li>
          <li><a href="https://policorp.com.br/blog" class="footer-link">Blog</a></li>
          <li><a href="https://policorp.com.br/faq" class="footer-link">FAQ</a></li>
          <li><a href="https://policorp.com.br/contato" class="footer-link">Contato</a></li>
          <li><a href="https://policorp.com.br/politica-de-privacidade" class="footer-link">Política de Privacidade</a></li>
        </ul>
      </div>

      <!-- Divisor -->
      <div class="footer-divider"></div>

      <!-- Coluna Sede Curitiba -->
      <div class="footer-column">
        <div class="footer-title-container">
          <h2 class="footer-title">Sede Curitiba</h2>
          <div class="title-line"></div>
        </div>
        <h3 class="footer-subtitle">Endereço:</h3>
        <p class="footer-text">Rua XV de Novembro, 964,<br>Curitiba - PR, Brasil.</p>
        
        <h3 class="footer-subtitle">Telefone:</h3>
        <p class="footer-text">+55 (41) 3500 7803</p>
        
        <h3 class="footer-subtitle">Email:</h3>
        <p class="footer-text">suporte@policorp.com.br</p>
      </div>

      <!-- Divisor -->
      <div class="footer-divider"></div>

      <!-- Coluna Sede Manaus -->
      <div class="footer-column">
        <div class="footer-title-container">
          <h2 class="footer-title">Sede Manaus</h2>
          <div class="title-line"></div>
        </div>
        <h3 class="footer-subtitle">Endereço:</h3>
        <p class="footer-text">Rua Belo Horizonte, 19, Sala 612<br>Manaus - AM, Brasil.</p>
        
        <h3 class="footer-subtitle">Telefone:</h3>
        <p class="footer-text">+55 (92) 3346 6400</p>
        
        <h3 class="footer-subtitle">Email:</h3>
        <p class="footer-text">suporte@policorp.com.br</p>
      </div>
    </div>

    <div class="social-icons">
    <a href="https://www.linkedin.com/company/policorp-tecnologia" target="_blank" rel="noopener">
      <img src="/imgs/linkedin.png" alt="LinkedIn">
    </a>
    <a href="https://www.youtube.com/@policorptecnologia" target="_blank" rel="noopener">
      <img src="/imgs//youtube.png" alt="YouTube">
    </a>
    <a href="https://www.facebook.com/policorptecnologia/" target="_blank" rel="noopener">
      <img src="/imgs/facebook.png" alt="Site da Policorp">
    </a>
    <a href="https://www.instagram.com/policorptec/" target="_blank" rel="noopener">
      <img src="/imgs/instagram.png" alt="Site da Policorp">
    </a>
  </div>

    <!-- Rodapé inferior -->
    <div class="footer-bottom">
      <p>© Policorp Tecnologia. Todos os direitos reservados.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PolicorpFooter'
};
</script>

<style scoped>

.social-icons {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}

.social-icons a {
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
}

.social-icons a:hover {
  transform: scale(1.1);
}

.social-icons img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.policorp-footer {
  background: linear-gradient(to right, #193B68, #193B68);
  color: #ffffff;
  padding: 40px 20px 20px;
  font-family: Arial, sans-serif;
}

.footer-columns {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  gap: 20px;
}

.footer-column {
  flex: 1;
  padding: 0 15px;
}

.footer-title-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.footer-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #ffffff;
  text-align: left;
  white-space: nowrap;
  margin-right: 10px;
}

.title-line {
  flex-grow: 1;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
  margin-left: 10px;
}

.footer-subtitle {
  font-size: 1.1rem;
  font-weight: bold;
  margin: 15px 0 5px;
  color: #ffffff;
  text-align: left;
}

.footer-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.footer-list li {
  margin-bottom: 8px;
}

.footer-link {
  color: #ffffff;
  text-decoration: none;
  display: block;
  transition: color 0.3s;
}

.footer-link:hover {
  color: rgb(120, 138, 219);  
}

.footer-text {
  margin: 0 0 15px;
  line-height: 1.5;
  color: #ffffff;
  text-align: left;
}

.footer-divider {
  width: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  margin: 0 10px;
}

.footer-bottom {
  text-align: center;
  padding-top: 30px;
  margin-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 0.9rem;
}

/* Responsividade */
@media (max-width: 768px) {
  .footer-columns {
    flex-direction: column;
  }

  .footer-divider {
    width: 100%;
    height: 1px;
    margin: 20px 0;
  }
  
  .footer-title {
    white-space: normal;
  }
}
</style>